import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { TaskDetailResponse, TaskMinList } from 'types/JobTypes';
import { UserType } from 'types/WorkLogTypes';

// import { buildQueryString } from 'utils/url';
import { APIResponse, BUSMAN_TAGS, busmanApiSlice } from './busmanApiSlice';
import { getApiErrorMessage } from './errors';

export const jobTaskEndpoints = busmanApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // getJobByProjectId: builder.query({
    //   query: ({ clientId, projectId, isActive = true }) =>
    //     `/client/jobs/${buildQueryString({
    //       client_id: clientId,
    //       project_id: projectId,
    //       is_active: isActive,
    //     })}`,
    //   providesTags: [BUSMAN_TAGS.Job],
    //   transformResponse: (response: APIResponse<any[]>) => response.data,
    //   transformErrorResponse: (response: FetchBaseQueryError) => getApiErrorMessage(response),
    // }),

    addJobTask: builder.mutation({
      query: (jobTaskPayload) => {
        return {
          url: '/jobs/task/',
          method: 'post',
          body: jobTaskPayload,
        };
      },
      invalidatesTags: [BUSMAN_TAGS.Job],
      transformResponse: (response: APIResponse<TaskDetailResponse>) => response.data,
      transformErrorResponse: (response: FetchBaseQueryError) => getApiErrorMessage(response),
    }),

    updateJobTaskById: builder.mutation({
      query: ({ taskId, updateTaskPayload }) => {
        return {
          url: `/jobs/task/${taskId}/`,
          method: 'put',
          body: updateTaskPayload,
        };
      },
      invalidatesTags: [BUSMAN_TAGS.Job],
      transformResponse: (response: APIResponse<TaskDetailResponse>) => response.data,
      transformErrorResponse: (response: FetchBaseQueryError) => getApiErrorMessage(response),
    }),

    updateJobTaskOrder: builder.mutation({
      query: (updateTaskOrderPayload) => {
        return {
          url: '/jobs/task/reorder',
          method: 'put',
          body: updateTaskOrderPayload,
        };
      },
      invalidatesTags: [BUSMAN_TAGS.Job],
      transformResponse: (response: APIResponse<TaskMinList>) => response.data,
      transformErrorResponse: (response: FetchBaseQueryError) => getApiErrorMessage(response),
    }),

    getTaskAssignees: builder.query({
      query: (jobList: string[]) => {
        return {
          url: '/jobs/task/assignees',
          method: 'post',
          body: { job_ids: jobList },
        };
      },
      providesTags: [BUSMAN_TAGS.Job],
      transformResponse: (response: APIResponse<UserType[]>) => response.data,
      transformErrorResponse: (response: FetchBaseQueryError) => getApiErrorMessage(response),
    }),
  }),
});

export const {
  useAddJobTaskMutation,
  useUpdateJobTaskByIdMutation,
  useUpdateJobTaskOrderMutation,
  useGetTaskAssigneesQuery,
} = jobTaskEndpoints;
